import { render, staticRenderFns } from "./Accesory.vue?vue&type=template&id=38824452&"
import script from "./Accesory.vue?vue&type=script&lang=js&"
export * from "./Accesory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports